<template>
  <div class="furnish-main">
    <el-tabs v-model="card_index">
      <el-tab-pane label="清缴费用" name="PaymentFees">
        <PaymentFees v-if="card_index==='PaymentFees'" />
      </el-tab-pane>
      <el-tab-pane label="出入证办理" name="CertificateProcessing">
        <CertificateProcessing v-if="card_index==='CertificateProcessing'" />
      </el-tab-pane>
      <el-tab-pane label="进场准备" name="PreparationForEntry">
        <PreparationForEntry v-if="card_index==='PreparationForEntry'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PaymentFees from "./components/preparation_entry/PaymentFees";
import CertificateProcessing from "./components/preparation_entry/CertificateProcessing";
import PreparationForEntry from "./components/preparation_entry/PreparationForEntry";
export default {
  name: "PreparationEntry",
  components: {PreparationForEntry, CertificateProcessing, PaymentFees},
  data(){
    return{
      card_index:"PaymentFees"
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(../../common.scss);
.furnish-main{
  height: calc(100vh - 230px);
  overflow-y: scroll;
  .el-link-common{
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/PreparationEntry.vue